<template>
  <div class="lineChart" :id="id"></div>
</template>

<script type="text/ecmascript-6">
import LineChart from './LineChart.js'
export default LineChart
</script>

<style lang="scss">
@import "LineChart.scss";
</style>



// WEBPACK FOOTER //
// src/components/echarts/LineChart/LineChart.vue